import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "@material-ui/core";
import axios from "axios";
import { requestRecaptcha } from "../../actions";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";

class ContactUsPageSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
      disableContactBtn: false,
      contactBtnText: "Send Message",
      showSuccessModal: false,
      showErrorModal: false,
      isVerified: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.API_URL = "https://api.teqengine.com/verifyRecaptcha";
    // "https://kr714949d0.execute-api.us-east-1.amazonaws.com/prod/verifyRecaptcha";
    // "http://localhost:4000/prod/verifyRecaptcha";
  }

  async isRecaptchaVerified(token) {
    // get result from lambda function
    // const { data: result } = await axios.post('http://localhost:4000/prod/verifyRecaptcha', { token })
    const { data: isVerifiedResult } = await axios.post(this.API_URL, {
      token,
    });
    this.setState({
      isVerified: isVerifiedResult,
    });
    this.props.dispatch(requestRecaptcha(isVerifiedResult));
  }

  changeBtnText(contactBtnText) {
    this.setState({ contactBtnText });
  }

  handleFormValueChange(inputName, event) {
    let stateValue = {};
    stateValue[inputName] = event.target.value;
    this.setState(stateValue);
  }

  async sendEmail() {
    const params = {
      email: this.state.email,
      name: this.state.name,
      phone: this.state.phone,
      company: this.state.company,
      message: this.state.message,
      formType: "Contact Page Form",
    };
    // // TODO: fix and re-implement recaptcha
    // let isVerified = false;
    // try {
    //   isVerified = this.props.recaptcha.isVerified;
    // } catch (e) {
    //   isVerified = false;
    // }
    let isVerified = true;
    if (isVerified) {
      // recaptcha verified, send email
      const { data: emailRes } = await axios.post(
        "https://api.teqengine.com/sendEmail",
        params
      );
      if (emailRes && emailRes.sent === true) {
        // email was sent successfully, open success modal
        this.clearForm();
        this.setState({
          showSuccessModal: true,
          showErrorModal: false,
        });
      } else {
        // email failed, open error modal
        this.setState({
          showSuccessModal: false,
          showErrorModal: true,
        });
      }
    } else {
      // recaptcha not verified, open error modal
      this.setState({
        disableBtn: false,
        showErrorModal: true,
        showSuccessModal: false,
      });
    }
  }

  clearForm() {
    this.setState({
      disableBtn: false,
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
    });
  }

  closeModal() {
    this.setState({
      showSuccessModal: false,
      showErrorModal: false,
    });
  }

  renderModalBody() {
    if (this.state.showSuccessModal) {
      // render success message
      return (
        <div className="contact-modal-content">
          <img
            className="contact-modal-close"
            src="img/close.svg"
            onClick={this.closeModal.bind(this)}
            alt="close modal"
          />
          <h4 className="contact-modal-title">Contact Status</h4>
          <div className="contact-modal-message">
            <img
              className="contact-modal-success-icon"
              src="img/success-icon.svg"
              alt="success check mark"
            />
            <div>Your email was sent successfully!</div>
            <div>We will get back to you ASAP.</div>
          </div>
        </div>
      );
    } else if (this.state.showErrorModal) {
      // render error message
      if (this.props.recaptcha && this.props.recaptcha.isVerified === false) {
        // if recaptcha failed then notify them to email straight to daniel@teqengine.com
        return (
          <div className="contact-modal-content">
            <img
              className="contact-modal-close"
              src="img/close.svg"
              onClick={this.closeModal.bind(this)}
              alt="close modal"
            />
            <h4 className="contact-modal-title">Contact Status</h4>
            <div className="contact-modal-message">
              <img
                className="contact-modal-success-icon"
                src="/img/failed-icon.svg"
                alt="failure alert icon"
              />
              <div>Email failed. Bot detected.</div>
              <div>
                If you are a human please email{" "}
                <a href="mailto:daniel@teqengine.com">daniel@teqengine.com</a>{" "}
                directly.
              </div>
              <div>Thank you for your patience!</div>
            </div>
          </div>
        );
      } else {
        // recaptcha was successful, must be nodemailer API error
        return (
          <div className="contact-modal-content">
            <img
              className="contact-modal-close"
              src="img/close.svg"
              onClick={this.closeModal.bind(this)}
              alt="close modal"
            />
            <h4 className="contact-modal-title">Contact Status</h4>
            <div className="contact-modal-message">
              <img
                className="contact-modal-success-icon"
                src="/img/failed-icon.svg"
                alt="failure alert icon"
              />
              <div>Your email failed to send.</div>
              <div>
                Please try again or email{" "}
                <a href="mailto:daniel@teqengine.com">daniel@teqengine.com</a>{" "}
                directly.
              </div>
              <div>Thank you!</div>
            </div>
          </div>
        );
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    // disable the button
    this.setState({ disableContactBtn: true });

    // send email
    this.sendEmail();
  }

  render() {
    return (
      <React.Fragment>
        {/* <GoogleReCaptcha
          onVerify={(token) => this.isRecaptchaVerified(token)}
        /> */}
        <section className="contact-us-section ptb-100">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-lg-9">
                <div className="section-heading mb-4">
                  <h2>Contact Us</h2>
                  <p className="lead">
                    Send us a message and we'll get back to you within 24 hours.
                    Find out how TeqEngine can transform your web presence and
                    drive your business forward. We offer quotes and a
                    complementary website audit and business consultation.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-between align-items-center">
              <div className="col-md-6">
                <form
                  method="POST"
                  id="contactForm1"
                  className="contact-us-form"
                  onSubmit={this.handleSubmit}
                >
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.name}
                          onChange={(e) =>
                            this.handleFormValueChange("name", e)
                          }
                          type="text"
                          className="form-control"
                          name="name"
                          placeholder="Enter name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.company}
                          onChange={(e) =>
                            this.handleFormValueChange("company", e)
                          }
                          type="text"
                          name="company"
                          size="40"
                          className="form-control"
                          id="company"
                          placeholder="Your Company"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.email}
                          onChange={(e) =>
                            this.handleFormValueChange("email", e)
                          }
                          type="email"
                          className="form-control"
                          name="email"
                          placeholder="Enter email"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.phone}
                          onChange={(e) =>
                            this.handleFormValueChange("phone", e)
                          }
                          type="text"
                          name="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Your Phone"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          onChange={(e) =>
                            this.handleFormValueChange("message", e)
                          }
                          value={this.state.message}
                          name="message"
                          id="message"
                          className="form-control"
                          rows="7"
                          cols="25"
                          placeholder="Message"
                          style={{ resize: "none" }}
                          required
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 mt-3">
                      <button
                        type="submit"
                        className="btn primary-solid-btn"
                        id="btnContactUs"
                        disabled={this.state.disableContactBtn}
                        // onClick={() => {
                        //   this.changeBtnText("Sending...");
                        // }}
                      >
                        {this.state.contactBtnText}
                      </button>
                    </div>
                  </div>
                </form>
                <p className="form-message"></p>
              </div>
              <div className="col-md-5">
                <div className="contact-info-wrap">
                  <ul className="list-creative">
                    <li>
                      <dl className="list-terms-medium email">
                        <dt>Email</dt>
                        <dd>
                          <ul className="list-comma">
                            <li>
                              {/* Support:{" "} */}
                              <a href="mailto:daniel@teqengine.com">
                                daniel@teqengine.com
                              </a>
                            </li>
                            {/* <li>
                              Query:{" "}
                              <a href="mailto:query@yourdomain.com">
                                query@yourdomain.com
                              </a>
                            </li> */}
                          </ul>
                        </dd>
                      </dl>
                    </li>
                    {/* <li>
                      <dl className="list-terms-medium phone">
                        <dt>Phone</dt>
                        <dd>
                          <ul className="list-comma">
                            <li>
                              Support:{" "}
                              <a href="tel:+1-111-111-1111">+1-111-111-1111</a>
                            </li>
                            <li>
                              Sales:{" "}
                              <a href="tel:+1-222-222-2222">+1-222-222-2222</a>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                    </li> */}
                    {/* <li>
                      <dl className="list-terms-medium address">
                        <dt>Address</dt>
                        <dd>
                          <p>
                            Remote, USA, (zip code here) <br /> United States{" "}
                          </p>
                        </dd>
                      </dl>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Modal
          className="contact-modal"
          open={this.state.showSuccessModal || this.state.showErrorModal}
          onClose={this.closeModal.bind(this)}
        >
          <div className="contact-modal-body">{this.renderModalBody()}</div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { recaptcha } = state;
  return { recaptcha };
};

export default connect(mapStateToProps)(ContactUsPageSection);
